import Action from '@/components/AgentActions/Action';
import PopoverForAgentList from '@/components/AgentActions/PopoverForAgentList';
import MakeCallPopover from '@/components/AgentActions/MakeCallPopover';
import AgentConnectionsSumPopover from './AgentConnectionsSumPopover';
import { hAsyncForEach, hDeepCopy } from '@/utils/helpers';
import TimeCounter from '@/components/AgentActions/TimeCounter';
import moment from 'moment';
import notificationMap from './notificationMap';
// @vue/component
export default {
  name: 'AgentActions',

  components: {
    Action,
    PopoverForAgentList,
    TimeCounter,
    MakeCallPopover,
    AgentConnectionsSumPopover,
    notificationMap,
  },

  props: {
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      longestBreakTime: '0',
      // timeCounter: 0,
      breakTime: 0,
      options: [],
      isLogged: false,
      isVisible: false,
      COUNT_TRY_VALUES: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      form: {
        selectedTryCount: 1,
        selectedCampaign: '',
      },
      rules: {
        selectedCampaign: [
          { required: true, message: 'Kampania jest wymagana.', trigger: 'blur' },
        ],
      }
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'user/agent/getAgentsBelongsToUserList',
        'user/agent/setStatus',
      ]);
    },
    isCampaignLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'campaign/startCampaign'
      ]);
    },
    selectedCampaignDetails() {
      return this.campaignsList.filter(campaign => campaign.uuid === this.form.selectedCampaign)[0];
    },
    selectedCampaignProject() {
      return this.projectsList.filter(project => project.id === this.selectedCampaignDetails.project_id)[0];
    },
    campaignsList() {
      return this.$store.getters['campaigns/list'].records;
    },
    projectsList() {
      return this.$store.getters['client/projects/list'].records;
    },
    agents() {
      return this.$store.getters['user/agent/agentsBelongsToUserlist'].records;
    },
    total() {
      return this.$store.getters['user/agent/agentsBelongsToUserlist'].total;
    },
    isAnyAgentLogged() {
      return this.$store.getters['user/agent/agentsBelongsToUserlist'].records.some(el => el.is_logged === true);
    },
    isAnyAgentOnDnd() {
      return this.$store.getters['user/agent/agentsBelongsToUserlist'].records.some(el => el.is_dnd === true);
    },
    isAnyAgentOnBreak() {
      return this.$store.getters['user/agent/agentsBelongsToUserlist'].records.some(el => el.is_paused === true && el.is_logged === true);
    },
    isAnyAgentAbleToCall() {
      return this.$store.getters['user/agent/agentsBelongsToUserlist'].records.some(el => el.massdial4call === true);
    },
    agentsAbleToCall() {
      return this.$store.getters['user/agent/agentsBelongsToUserlist'].records.filter(el => el.massdial4call === true);
    },
    getTheLongestBreak() {
      const agents = this.cleanEmptyBreak(hDeepCopy(this.agents));
      if (agents.length !== 0) {
        return agents.reduce(
          (a, b) => (
            moment(a.break_time_left, 'HH:mm:ss').diff(moment().startOf('day'), 'seconds')
              < moment(b.break_time_left, 'HH:mm:ss').diff(moment().startOf('day'), 'seconds') ? b : a
          ),
        ).break_time_left;
      }
      return '0';
    },
  },
  async created() {
    this.prepareBreakOptions();
    await this.getAgentsList();
    this.$socket.$on('agentChangeStatusInformation', (payload) => {
      const changedStatus = this.getChangedValue(payload);
      const notificationText = changedStatus.status
        ? notificationMap[changedStatus.name].textTrue
        : notificationMap[changedStatus.name].textFalse;


      if (changedStatus.name === 'isTalking') {
        const callerDetails = changedStatus.status ? payload : {};
        this.$store.commit('user/agent/SET_CALLING_AGENT_DETAILS', callerDetails);
      }
      this.$message({
        title: 'Sukces',
        message: `${notificationText} ${payload.agent_name} dla projektu: ${payload.project_name}`,
        type: changedStatus.name === 'isTalking' ? 'warning' : 'success',
      });
      this.getAgentsList();
    });
  },
  beforeDestroy() {
    this.$socket.$offAll(['agentChangeStatusInformation']);
  },
  methods: {
    getChangedValue(allValues) {
      if (allValues.previous_is_logged !== allValues.is_logged) return { name: 'isLogged', status: allValues.is_logged };
      if (allValues.previous_is_paused !== allValues.is_paused) return { name: 'isPaused', status: allValues.is_paused };
      if (allValues.previous_is_talking !== allValues.is_talking) return { name: 'isTalking', status: allValues.is_talking };
      if (allValues.previous_is_dnd !== allValues.is_dnd) return { name: 'isDnd', status: allValues.is_dnd };
      // dodane bo czasem jest sytuacja ze previous_is_talking i is_talking jest true
      if (allValues.is_talking) return { name: 'isTalking', status: allValues.is_talking };
      return '';
    },
    prepareBreakOptions() {
      for (let i = 5; i < 65; i += 5) {
        this.options.push({
          value: `${i}`,
          label: `${i} minut`,
        });
      }
    },
    cleanEmptyBreak(agents) {
      agents.forEach((agent, index, object) => {
        if (agent.break_time_left === null) {
          object.splice(index, 1);
        }
      });
      return agents;
    },
    async getAgentsList() {
      await this.$store.dispatch('user/agent/getAgentsBelongsToUserList');
    },
    async handleChangeStatus(values) {
      await hAsyncForEach(this.agents, async (elem) => {
        let params = {
          agent: elem.uuid,
          status: !values.status,
          action_id: values.actionId,
        };
        if ('interval' in values) {
          params.interval = values.interval;
        }
        await this.$store.dispatch('user/agent/setStatus', params);
        this.getAgentsList();
        this.$refs.popoverForAgentList.breakTime = 0;
      });
    },
    startCampaign() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const params = {
            project_uuid: this.selectedCampaignProject.uuid,
            campaign_uuid: this.selectedCampaignDetails.uuid,
            limit: this.form.selectedTryCount,
          }
          const responseStatus = await this.$store.dispatch('campaign/startCampaign', params);
          if (responseStatus === 200) {
            this.$message({
              type: 'success',
              message: "Kampania została uruchomiona.",
            });
            await this.$store.dispatch('campaigns/getList');
          } else {
            this.$message({
              type: 'error',
              message: "Wystąpił błąd podczas uruchamiania kampanii",
            });
          }
          this.isVisible = false;
        }
      })
    },
  },
};
